import React from 'react';
import { useIntl } from 'react-intl';

const DataPolicyTab = () => {
  const intl = useIntl();

  return (
    <div>
      <h3>{intl.formatMessage({ id: 'Data Policy Disclaimer'})}</h3>
      <p>
        {intl.formatMessage({ id: 'At Uniplaces we are commited to transparency regarding the data that you trust us with.' })}
      </p>
      <p>
        {intl.formatMessage({ id: 'Our policies are therefore public and available for you to read and be aware of how we deal with data within Uniplaces.' })}
      </p>
      <h3>{intl.formatMessage({ id: 'General Data Policy' })}</h3>
      <p>
        <a
          href='https://s3-eu-west-1.amazonaws.com/uniplaces.com.terms/Uniplaces_General_Data_Protection_Policy-20190108.pdf'
          target='_blank'
          rel='noopener noreferrer'
        >
          {intl.formatMessage({ id: 'Uniplaces General Data Protection Policy' })}
        </a>
      </p>
      <h3>{intl.formatMessage({ id: 'Transparent Processing – Privacy Notices' })}</h3>
      <p>
        {intl.formatMessage({ id: 'As part of our commitment for transparency this section also has a list of all the privacy notices that are used at Uniplaces' })}
      </p>
      <ul>
        <li>
          <a
            href='https://s3-eu-west-1.amazonaws.com/uniplaces.com.terms/Uniplaces_Data_Retention_Policy-20180524.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage({ id: 'Uniplaces Data Retention' })}
          </a>
        </li>
        <li>
          <a
            href='https://s3-eu-west-1.amazonaws.com/uniplaces.com.terms/Uniplaces_Employee_Privacy_Statement-20180524.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage({ id: 'Uniplaces Employee Privacy Statement' })}
          </a>
        </li>
        <li>
          <a
            href='https://s3-eu-west-1.amazonaws.com/uniplaces.com.terms/Uniplaces_Personal_Data_Breach_Notification_Policy-20190110.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage({ id: 'Uniplaces Personal Data Breach Policy' })}
          </a>
        </li>
        <li>
          <a
            href='https://s3-eu-west-1.amazonaws.com/uniplaces.com.terms/Uniplaces_Rights_of_Individuals_Policy-20190108.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            {intl.formatMessage({ id: 'Uniplaces Rights of Individuals' })}
          </a>
        </li>
      </ul>
      <p>{intl.formatMessage({ id: 'This guide was last updated on January 10th 2019.' })}</p>
    </div>
  );
}

export default DataPolicyTab;
